package com.mgacreative.hotelru.domain.repository

import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import com.mgacreative.hotelru.core.tenant.TenantSession
import com.mgacreative.hotelru.domain.model.Room
import io.github.jan.supabase.postgrest.postgrest

class RoomRepository(
    private val networkClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession? = null
) {
    private val demoRooms = mutableListOf(
        Room(id = "demo-101", tenantId = "demo-tenant-isolated", roomNumber = "101", roomType = "Standard", status = "CLEAN"),
        Room(id = "demo-102", tenantId = "demo-tenant-isolated", roomNumber = "102", roomType = "Superior", status = "OCCUPIED"),
        Room(id = "demo-103", tenantId = "demo-tenant-isolated", roomNumber = "103", roomType = "Suite", status = "DIRTY"),
        Room(id = "demo-201", tenantId = "demo-tenant-isolated", roomNumber = "201", roomType = "Standard", status = "CLEAN"),
        Room(id = "demo-202", tenantId = "demo-tenant-isolated", roomNumber = "202", roomType = "Executive", status = "CLEAN"),
        Room(id = "demo-203", tenantId = "demo-tenant-isolated", roomNumber = "203", roomType = "Family", status = "MAINTENANCE")
    )
    
    suspend fun getRooms(): List<Room> {
        if (tenantSession?.isDemoMode == true) {
            return demoRooms.toList()
        }
        return try {
            networkClient.client.postgrest["rooms"]
                .select()
                .decodeList<Room>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            emptyList()
        }
    }

    suspend fun addRoom(room: Room): Room? {
        if (tenantSession?.isDemoMode == true) {
            val created = room.copy(id = "demo-${room.roomNumber}")
            demoRooms.add(created)
            return created
        }
        return try {
            networkClient.client.postgrest["rooms"]
                .insert(room) { select() }
                .decodeSingleOrNull<Room>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }

    suspend fun updateRoom(room: Room): Room? {
        if (tenantSession?.isDemoMode == true) {
            val idx = demoRooms.indexOfFirst { it.id == room.id }
            if (idx != -1) {
                demoRooms[idx] = room
            }
            return room
        }
        return try {
            networkClient.client.postgrest["rooms"]
                .update(room) {
                    filter {
                        eq("id", room.id ?: "")
                    }
                    select()
                }
                .decodeSingleOrNull<Room>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }

    suspend fun deleteRoom(roomId: String): Boolean {
        if (tenantSession?.isDemoMode == true) {
            return demoRooms.removeAll { it.id == roomId }
        }
        return try {
            networkClient.client.postgrest["rooms"]
                .delete {
                    filter {
                        eq("id", roomId)
                    }
                }
            true
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            false
        }
    }

    suspend fun updateRoomStatus(roomId: String, status: String): Boolean {
        if (tenantSession?.isDemoMode == true) {
            val idx = demoRooms.indexOfFirst { it.id == roomId }
            if (idx != -1) {
                demoRooms[idx] = demoRooms[idx].copy(status = status)
            }
            return true
        }
        return try {
            networkClient.client.postgrest["rooms"]
                .update({ set("status", status) }) {
                    filter {
                        eq("id", roomId)
                    }
                }
            true
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            false
        }
    }
}

